/**
 * Getter Dependencies
 */
import { get } from 'lodash'

/**
 * Retrieve the currently bound project
 *
 * @param  {Object} state
 * @return {Object}
 */
const currentProject = (state) => {
    return state.data
}

/**
 * Get the pending state for the project
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const isPending = (state) => {
    return state.pending
}

/**
 * Return the tab count
 *
 * @param  {Object} state
 * @return {Integer}
 */
const tabCount = (state) => {
    return Object.keys(get(state.data, 'summary_context.tabs', {})).length
}

/**
 * Return the project labels
 *
 * @param  {Object} state
 * @return {Array}
 */
const projectLabels = (state) => {
    return get(state.data, 'summary_context.labels', [])
}

/**
 * Return the project tabs
 *
 * @param  {Object} state
 * @return {Object}
 */
const projectTabs = (state) => {
    return get(state.data, 'summary_context.tabs', {})
}

/**
 * Determine if the privileges array is empty
 *
 * @return {Boolean}
 */
const hasPrivileges = (state) => {
    return state.management.privileges.length > 0
}

/**
 * Determine if the invites array is empty
 *
 * @return {Boolean}
 */
const hasInvites = (state) => {
    return state.management.invites.length > 0
}

/**
 * Get the invitation count
 *
 * @param  {Object} state
 * @return {Number}
 */
const inviteCount = (state) => {
    return state.management.invites.length
}

/**
 * Return the privilege count
 *
 * @param  {Object} state
 * @return {Number}
 */
const privilegeCount = (state) => {
    return state.management.privileges.length
}

/**
 * Determine if the property type is multifamily
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const isMultiFamilyDeal = state => state.data.property_type === 'MF'

/**
 * Determine if the leaf is a R_MF_buy_and_hold
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const isRMFBuyHoldDeal = state => state.data.leaf === 'R_MF_buy_and_hold'

export default {
    tabCount,
    isPending,
    hasInvites,
    projectTabs,
    inviteCount,
    projectLabels,
    hasPrivileges,
    currentProject,
    privilegeCount,
    isRMFBuyHoldDeal,
    isMultiFamilyDeal
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/getters.js